module.exports = "<template>\r\n</template>\r\n";